import React, {useEffect, useState} from 'react'
import { connect } from "react-redux";
import {confirmAlert} from "react-confirm-alert";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";


// components
import XwitchLogForm from "./_form";
import XwitchLogFilters from "./_filters";
import Separator from "../../../components/Separator";
import CSVButton from "../../../components/buttons/CSVButton";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ConfirmDepurate} from "../../../components/confirmAlertForms/ConfirmDepurate";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";
import ConfirmSyncLogError from "../../../components/confirmAlertForms/ConfirmSyncLogError";


// labels
import {LIST, NO_DATA_FOUND, VIEW_DETAIL,} from "../../../components/i18n/i18n";


// actions
import { genericActions } from "../../../redux/actions/generics/GenericActions";
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { remove } from "../../../redux/actions/comunication/notificationActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";

// providers
import {paymentStatusProvider} from "../../../providers/xwitchLogProvider";

// services
import {xwitchLogService} from "../../../jwt/_services/bi/xwitchLogService";
import ConfirmSyncPaymentMethod from "../../../components/confirmAlertForms/ConfirmSyncPaymentMethod";



const XwitchLogList = props => {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    const [exportData, setExportData] = useState([])

    const xswitch_log_headers = [
        { label:'Fecha', key:'registerDate' },
        { label:'Aplicación', key:'app' },
        { label:'ID de Venta', key:'salesId' },
        { label:'OS', key:'os' },
        { label:'Método de Pago', key:'paymentMethod' },
        { label:'Método Solicitado', key:'xwitchMethod' },
        { label:'Mensaje', key:'message' },
        { label:'Error', key:'errorType' },
        { label:'Más detalle', key:'shareLink' },
    ]

    // asignar los valores por default del filtro
    useEffect( () => {
        if( filter )
            return

        props.setFilter( {
            xwitchLog: {
                salesId             : null,
                registerDate        : null,
                transactionStatus    : null,
            }
        }) ;
    }, [ ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericActions.search(xwitchLogService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);


    // Dar formato a los datos para exportar
    useEffect(() => {

        if(!listDomainObjects)
            return

        formatDataToExport()

    }, [listDomainObjects]);




    // formatear los datos para exportar
    const formatDataToExport = () => {
        const dataToExport = listDomainObjects.map( ({registerDate,
                                                         app,
                                                         xwitchMethod,
                                                         shareLink,
                                                         salesId,
                                                         os,message,
                                                         errorType,
                                                         paymentMethod}) => {

            //const localShareLinks = utilHelper.baseEndPointWeb() + 'xwitchLog/' + id;
            return {
                registerDate,
                salesId,
                app,
                xwitchMethod,
                shareLink,
                os,
                message,
                errorType,
                paymentMethod:paymentMethod ? paymentMethod.name : '',
            }
        })

        setExportData(dataToExport)
    }






    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(XwitchLogForm, { data, Form: XwitchLogForm })
    }

    const paymentStatusFormatter = (cell, row) => {
        const item = paymentStatusProvider.getItem(row.paymentStatus);
        return item?.row;
    }

    const confirmDepurate = _ => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside:true,
        customUI: ({onClose}) => <ConfirmDepurate onClose={onClose}/>
    })


    const syncErrorTypes = _ => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <ConfirmSyncLogError onClose={onClose}/>
    })


    const syncPaymentMethod = _ => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <ConfirmSyncPaymentMethod onClose={onClose}/>
    })

    const actionsFormatter = (cell, row) => <GenericTableButton toolTip={VIEW_DETAIL} icon={'fa-eye'} permission={'edit'} onClick={() => editItem(row)}/>






    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'registerDate',
            text: 'Fecha de registro',
            headerStyle: {width: '180px'},
        }, {
            dataField: 'app',
            text: 'APP',
            headerStyle: {width: '95px'},
        }, {
            dataField: 'os',
            text: 'OS',
            headerStyle: {width: '95px'},
        }, {
            dataField: 'salesId',
            text: 'Id de venta',
            headerStyle: {width: '100px'},
        },{
            dataField: 'clientName',
            text: 'Cliente',
            hidden: true
        }, {
            dataField: 'currency',
            text: 'Moneda',
            headerStyle: {width: '80px'},
        }, {
            dataField: 'paymentStatus',
            text: 'Estatus pago',
            headerStyle: {width: '120px'},
            formatter: paymentStatusFormatter
        }, {
            dataField: 'paymentMethod',
            text: 'Método de pago',
            formatter: (cell, row) => row?.paymentMethod?.name,
        }, {
            isDummyField: true,
            text: 'Tipo de solicitud',
            headerStyle: {width: '120px'},
            hidden: !filter?.xwitchLog?.paymentMethod,
            formatter: (cell, row) => {
                if(row?.paymentMethod?.name !== 'PayPal')
                    return ''

                if(row?.xwitchMethod === 'SetBooking' )
                    return  'Solicitud de Pago'

                return 'Confirmación de Pago'
            }
        }, {
            dataField: 'message',
            text: 'Comentarios',
        },{
            dataField: 'xwitchMethod',
            text: 'Metodo',
            headerStyle: {width: '100px'},
            hidden: true,
        }, {
            dataField: 'errorType',
            text: 'Error',
            hidden: !(filter?.xwitchLog?.transactionStatus === 'ERROR'),
        }, {
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '120px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'warning-secondary'}
                    label={'Depurar'}
                    toolTip={'Unifica los registros que tienen mismo TransactionId segun el rango de fechas seleccionado'}
                    icon={'fa-sync'}
                    permission={'edit'}
                    onClick={confirmDepurate}/>

                <Separator/>

                <CSVButton
                    title={'xswitch_log'}
                    headers={xswitch_log_headers}
                    data={exportData}
                />
            </div>
        </CardTitle>

        <XwitchLogFilters/>

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    remove,
})

export default connect(mapStateToProps, mapActionsToProps)(XwitchLogList)